import {Table, Space} from 'antd'

import styles from './CashflowForecastTable.module.scss'
import useStore from 'base/store'
import {Text, RotateArrowThirdIcon, MoneySecondIcon} from 'common/components'
import {formatMoney} from 'common/helpers'
import {CashflowForecastValue} from '..'

interface CashflowForecastTableProps {
  data: CashflowForecastValue[]
}

interface SummaryCellProps {
  index: number
  item: CashflowForecastValue
}

const SummaryCell = ({index, item}: SummaryCellProps) => {
  const positive = item.amount > 0

  return (
    <Table.Summary.Cell index={index}>
      <span className={positive ? styles.success : undefined}>
        {formatMoney(Math.abs(item.amount), {
          prefix: false,
          parentheses: positive,
        })}
      </span>
    </Table.Summary.Cell>
  )
}

export default function CashflowForecastTable({
  data,
}: CashflowForecastTableProps) {
  const role = useStore((state) => state.role)

  const columns = [
    {
      title: '',
      dataIndex: 'title',
    },
    ...data.map((item) => ({
      title: item.month,
      dataIndex: item.month,
    })),
  ]

  const dataSource = [
    {
      key: '1',
      title: (
        <Space size={6}>
          <RotateArrowThirdIcon className={styles.icon} />
          Repayments
        </Space>
      ),
      ...data.reduce((obj, item) => {
        obj[item.month] = formatMoney(item.repaymentsAmount, {prefix: false})
        return obj
      }, {} as any),
    },
    {
      key: '2',
      title: (
        <Space size={6}>
          <RotateArrowThirdIcon />
          Drawdowns
        </Space>
      ),
      ...data.reduce((obj, item) => {
        obj[item.month] = formatMoney(item.drawdownsAmount, {
          prefix: false,
          parentheses: true,
        })
        return obj
      }, {} as any),
    },
    {
      key: '3',
      title: <span className={styles.total}>Total</span>,
      ...data.reduce((obj, item) => {
        obj[item.month] = formatMoney(Math.abs(item.totalDiff), {
          prefix: false,
          parentheses: item.diffType === 'drawdown',
        })
        return obj
      }, {} as any),
    },
  ]

  return (
    <Table
      className={styles.root}
      pagination={false}
      size="small"
      columns={columns}
      dataSource={dataSource}
      summary={
        role.manager
          ? undefined
          : () => (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                  <Space size={6}>
                    <MoneySecondIcon />
                    <Text as="span" weight="demiBold" size="md">
                      Available fund
                    </Text>
                  </Space>
                </Table.Summary.Cell>
                {data.map((item, index) => (
                  <SummaryCell key={item.month} index={index} item={item} />
                ))}
              </Table.Summary.Row>
            )
      }
    />
  )
}
